<template>
  <el-table-column
    prop="creator_user.last_name"
    sortable="custom"
    label="Rögzítette"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span v-if="scope.row.creator_user">{{ scope.row.creator_user.last_name }} {{ scope.row.creator_user.first_name }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user.last_name',
  };
</script>
